var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { KeycloakEntity } from '../shared/KeycloakEntity';
import { BASE_URL_SERVICES, EVENT_ON_ERROR } from './constants';
import { windowExist } from 'src/shared/constants';
export var E_REQUEST_METHOD;
(function (E_REQUEST_METHOD) {
    E_REQUEST_METHOD["DELETE"] = "DELETE";
    E_REQUEST_METHOD["GET"] = "GET";
    E_REQUEST_METHOD["PATCH"] = "PATCH";
    E_REQUEST_METHOD["POST"] = "POST";
    E_REQUEST_METHOD["PUT"] = "PUT";
})(E_REQUEST_METHOD || (E_REQUEST_METHOD = {}));
var parseAxiosResponse = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        return [2 /*return*/, {
                url: (_a = response === null || response === void 0 ? void 0 : response.config) === null || _a === void 0 ? void 0 : _a.url,
                headers: response === null || response === void 0 ? void 0 : response.headers,
                status: response === null || response === void 0 ? void 0 : response.status,
                payload: response === null || response === void 0 ? void 0 : response.data,
            }];
    });
}); };
var parseAxiosError = function (err) { return __awaiter(void 0, void 0, void 0, function () {
    var error, status, errorMessage;
    var _a, _b, _c, _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0: return [4 /*yield*/, err];
            case 1:
                error = _f.sent();
                status = (error === null || error === void 0 ? void 0 : error.status) || ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) || 520 // unknown error code
                ;
                errorMessage = "".concat(status, " : ").concat((error === null || error === void 0 ? void 0 : error.message) || 'Unknown error');
                return [2 /*return*/, {
                        url: (_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.config) === null || _c === void 0 ? void 0 : _c.url,
                        headers: (_d = error === null || error === void 0 ? void 0 : error.response) === null || _d === void 0 ? void 0 : _d.headers,
                        status: status,
                        error: true,
                        errorMessage: errorMessage,
                        payload: (error === null || error === void 0 ? void 0 : error.data) || ((_e = error === null || error === void 0 ? void 0 : error.response) === null || _e === void 0 ? void 0 : _e.data),
                    }];
        }
    });
}); };
var triggerErrorEvent = function (status, message, url) {
    var fetchApiError = new CustomEvent(EVENT_ON_ERROR, {
        detail: { status: status, message: message, url: url },
    });
    if (windowExist) {
        document.dispatchEvent(fetchApiError);
    }
};
/**
 * Stock url with abortController associated, we must create new ServiceHelpers object for each request,
 * Static don't get value updated after initialization
 * Two way to abort, we can use
 *  - ServiceHelper.instance.abortController or
 *  - Try to find url in ServiceHelpers.callOnProcess which is a singleton through app
 *  When using the second case, be careful because the request could already be removed from the singleton and lead to a null error
 */
var ServiceHelpers = /** @class */ (function () {
    function ServiceHelpers(method, url) {
        var _this = this;
        this.addCallToOnProcess = function () {
            var _a;
            ServiceHelpers.callOnProcess = __assign(__assign({}, ServiceHelpers.callOnProcess), (_a = {}, _a[_this.url] = _this.abortController, _a));
        };
        this.removeCallToOnProcess = function () {
            delete ServiceHelpers.callOnProcess[_this.url];
            _this.abortController = null;
        };
        this.abortController = new AbortController();
        this.instance = axios.create({ signal: this.abortController.signal });
        this.instance.defaults.headers.common = {};
        this.url = url;
        this.requestParams = {
            baseURL: BASE_URL_SERVICES,
            headers: {
                accept: 'application/json',
                'Content-Type': 'application/json',
            },
            method: method,
            url: url,
        };
    }
    ServiceHelpers.prototype.callAuth = function (requestParams) {
        var _this = this;
        var _a;
        var params = requestParams.params, data = requestParams.data, headers = requestParams.headers, enableDefaultEvents = requestParams.enableDefaultEvents, noCache = requestParams.noCache;
        this.addCallToOnProcess();
        this.requestParams = __assign(__assign(__assign({}, this.requestParams), params), { url: noCache ? "".concat(this.url, "?t=").concat(new Date().getTime()) : this.url, data: data, headers: __assign(__assign(__assign({}, this.requestParams.headers), { authorization: "Bearer ".concat((_a = KeycloakEntity === null || KeycloakEntity === void 0 ? void 0 : KeycloakEntity.kc) === null || _a === void 0 ? void 0 : _a.token) }), headers) });
        return this.instance(this.requestParams)
            .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
            var responseParsed;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, parseAxiosResponse(response)];
                    case 1:
                        responseParsed = _a.sent();
                        if (responseParsed.status === 401) {
                            KeycloakEntity.logout();
                        }
                        return [2 /*return*/, Promise.resolve(responseParsed)];
                }
            });
        }); })
            .catch(function (err) { return __awaiter(_this, void 0, void 0, function () {
            var responseAborted, errorParsed, isAbortError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.abortController.signal.aborted) return [3 /*break*/, 2];
                        return [4 /*yield*/, parseAxiosResponse(err)];
                    case 1:
                        responseAborted = _a.sent();
                        return [2 /*return*/, Promise.resolve(responseAborted)];
                    case 2: return [4 /*yield*/, parseAxiosError(err)];
                    case 3:
                        errorParsed = _a.sent();
                        isAbortError = this.abortController.signal.aborted;
                        if (errorParsed.status === 401) {
                            KeycloakEntity.logout();
                        }
                        // If we don't want to dispatch default event, we can disable it
                        if (enableDefaultEvents && !isAbortError) {
                            triggerErrorEvent(errorParsed.status, errorParsed.errorMessage, this.url);
                        }
                        return [2 /*return*/, Promise.resolve(errorParsed)];
                }
            });
        }); })
            .finally(function () { return _this.removeCallToOnProcess(); });
    };
    ServiceHelpers.prototype.call = function (requestParams) {
        var _this = this;
        var params = requestParams.params, data = requestParams.data, headers = requestParams.headers, enableDefaultEvents = requestParams.enableDefaultEvents, noCache = requestParams.noCache;
        this.addCallToOnProcess();
        this.requestParams = __assign(__assign(__assign({}, this.requestParams), params), { url: noCache ? "".concat(this.url, "?t=").concat(new Date().getTime()) : this.url, data: data, headers: __assign(__assign({}, this.requestParams.headers), headers) });
        return this.instance(this.requestParams)
            .then(function (response) { return Promise.resolve(parseAxiosResponse(response)); })
            .catch(function (err) { return __awaiter(_this, void 0, void 0, function () {
            var errorParsed, isAbortError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, parseAxiosError(err)];
                    case 1:
                        errorParsed = _a.sent();
                        isAbortError = this.abortController.signal.aborted;
                        // If we don't want to dispatch default event, we can disable it
                        if (enableDefaultEvents && !isAbortError) {
                            triggerErrorEvent(errorParsed.status, errorParsed.errorMessage, this.url);
                        }
                        return [2 /*return*/, Promise.resolve(errorParsed)];
                }
            });
        }); })
            .finally(function () { return _this.removeCallToOnProcess(); });
    };
    ServiceHelpers.callOnProcess = {};
    return ServiceHelpers;
}());
export { ServiceHelpers };
